import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from 'react-dom';
import App from './App';
/*
 * Render the GUI playground. This is a separate function because importing anything
 * that instantiates the VM causes unsupported browsers to crash
 * {object} appTarget - the DOM element to render to
 */
// eslint-disable-next-line import/no-anonymous-default-export
export default (function (Test) {
    ReactDOM.render(
    // <React.StrictMode>
    _jsx(App, {}, void 0), Test
    // </React.StrictMode>,
    );
});
